import { resetAuthState, resetTemporaryPassword } from './SignUpResend.commands';

import { getEmail } from '/b2b/authentication/state/Auth.selectors';
import { getUrlParams } from '/b2b/common/state/selectors';

export const mapStateToProps = state => {
    return {
        email: getUrlParams(state, 'email') || getEmail(state),
    };
};

export const mapDispatchToProps = {
    resetAuthState,
    resetTemporaryPassword,
};
